import React from "react";

interface GridSvgProps {
  active: boolean;
}

export default function GridSvg({ active }: GridSvgProps): React.JSX.Element {
  return (
    <svg
      width="33px"
      height="33px"
      viewBox="0 0 24.00 24.00"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform="rotate(0)"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0" />

      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />

      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          d="M3.5 3.5H10.5V10.5H3.5V3.5Z"
          stroke="#000000"
          strokeWidth="0.8"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={`${active ? "stroke-[#0097ab]" : ""}`}
        />{" "}
        <path
          d="M3.5 13.5H10.5V20.5H3.5V13.5Z"
          stroke="#000000"
          strokeWidth="0.8"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={`${active ? "stroke-[#0097ab]" : ""}`}
        />{" "}
        <path
          d="M13.5 3.5H20.5V10.5H13.5V3.5Z"
          stroke="#000000"
          strokeWidth="0.8"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={`${active ? "stroke-[#0097ab]" : ""}`}
        />{" "}
        <path
          d="M13.5 13.5H20.5V20.5H13.5V13.5Z"
          stroke="#000000"
          strokeWidth="0.8"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={`${active ? "stroke-[#0097ab]" : ""}`}
        />{" "}
      </g>
    </svg>
  );
}
